//Se agrego esto para setear en prod primero el path correcto en runtime
import "./set-public-path";

import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { startDeployVersionWatcher } from "./services/getAppConfig";

startDeployVersionWatcher();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
